import React, { Suspense } from "react";
import { Spin } from "antd";

const styles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
};

export default function lazyload(Comp) {
  return (
    <Suspense fallback={<Spin size="large" style={styles} />}>
      <Comp />
    </Suspense>
  );
}

